import React, {useState} from 'react';
import {consignorService} from '../../../services';
import {Modal, Input, notification, Button, Spin} from 'antd';
import i18n from '../../../i18n';

export default function ModalRefuseOrder({isShow, setIsShow, setIsNeedUpdate, orderId}) {

  const {TextArea} = Input;
  const [loading, setLoading] = useState(false);
  const [refuseReason, setRefuseReason] = useState('');

  const handleRefuse = () => {
    setLoading(true);
    consignorService
      .refuseOrder(orderId, refuseReason)
      .then(resp => {
        if (resp.code !== 400) {
          notification.success(
            { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
              description: resp.message });
          setIsShow(false);
          setIsNeedUpdate(true);
        } else {
          notification.error(
            { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
              description: resp.message });
        }
      })
      .catch(errMsg => notification.error(
          { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
            description: errMsg })
      )
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title={i18n.t('modals.modalRefuseOrder.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
          <Button disabled={!refuseReason} onClick={handleRefuse} className="small-button typical-btn-red">{i18n.t('main.buttons.decline')}</Button>
      ]}
    >
        <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
            <TextArea rows={4} onChange={e => setRefuseReason(e.target.value)} value={refuseReason} description={i18n.t('modals.modalRefuseOrderToConsignor.fields.refuseReason.title')} />
        </Spin>
    </Modal>
  );

}
